// Polyfills
//import 'whatwg-fetch'; // polyfill fetch (<2017)
//import 'promise-polyfill/src/polyfill'; // polyfill promises for fetch (IE11)
//import 'core-js/stable'; // polyfill promises and ES2015 methods (mainly IE11) https://github.com/zloirock/core-js

// Libraries should be imported in a module using them
//import Vue from 'vue';
//import 'slick-carousel';
//import 'magnific-popup';

// Custom modules
import "./modules/input-detection";
import "./modules/menu";
import "./modules/print-page";
import "./modules/file-upload";
import "./modules/caption";
import { search } from "./modules/search";
import { searchpage } from "./modules/searchpage";
import { cookies } from './modules/cookies';
//import './modules/googleanalytics'; // track links as events
//import { analytics } from './modules/analytics'; // methods for tracking custom events and pageviews
import components from './components/all';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/modal';
